import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { TrackingParams, TrackingService } from '../../services/tracking.service';

@Injectable({ providedIn: 'root' })
export class TrackingResolver implements Resolve<TrackingParams> {
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TrackingParams> {
        if (!TrackingService.read()) {
            TrackingService.store({
                agent: window.navigator.userAgent,
                queryParams: route.queryParams,
                referrer: document.referrer,
                target: state.url,
            });
        }

        return of(TrackingService.read());
    }
}
